import React from "react";

import { ExtendedNextPage } from "types/pages";
import Main from "./components/Main";

const LeadFlow: ExtendedNextPage = () => {
  return <Main plan="BASIC" />;
};

LeadFlow.getLayout = (page) => {
  return <div>{page}</div>;
};

export default LeadFlow;
